import { useState, type ReactNode } from 'react';
import SiteHeader from './SiteHeader';
import SiteFooter from './SiteFooter';
import SidePanel from './SidePanel';

interface SiteLayoutProps {
  children: ReactNode;
  sidebar?: boolean;
}

export default function SiteLayout({ children, sidebar = false }: SiteLayoutProps) {
  const [drawerOpen, setDrawerOpen] = useState(false);

  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <SiteHeader />
      <main className="flex-1 w-full px-4 md:px-6 py-6 md:py-8">
        {sidebar ? (
          <>
            <div className="lg:hidden mb-5">
              <button
                type="button"
                onClick={() => setDrawerOpen(true)}
                className="inline-flex items-center gap-2 h-10 px-4 rounded-md border border-background-200 bg-background-50 text-sm font-medium text-foreground-800 cursor-pointer"
              >
                <i className="ri-filter-3-line text-primary-500" aria-hidden="true" />
                分类筛选与专题入口
              </button>
            </div>
            <div className="flex flex-col lg:flex-row gap-6 lg:gap-8">
              <div className="hidden lg:block lg:w-[272px] shrink-0">
                <div className="sticky top-24">
                  <SidePanel />
                </div>
              </div>
              <div className="flex-1 min-w-0">{children}</div>
            </div>
          </>
        ) : (
          children
        )}
      </main>
      <SiteFooter />

      {drawerOpen && (
        <div className="fixed inset-0 z-50 lg:hidden">
          <div
            className="absolute inset-0 bg-foreground-950/40"
            onClick={() => setDrawerOpen(false)}
            aria-hidden="true"
          />
          <div className="absolute left-0 top-0 bottom-0 w-[86%] max-w-sm overflow-y-auto bg-background-50 p-4">
            <div className="flex items-center justify-between mb-4">
              <span className="font-heading text-base font-bold text-foreground-950">筛选与专题</span>
              <button
                type="button"
                onClick={() => setDrawerOpen(false)}
                className="w-9 h-9 flex items-center justify-center rounded-md border border-background-200 text-foreground-700 cursor-pointer"
                aria-label="关闭"
              >
                <i className="ri-close-line text-lg" aria-hidden="true" />
              </button>
            </div>
            <SidePanel onNavigate={() => setDrawerOpen(false)} />
          </div>
        </div>
      )}
    </div>
  );
}